import { Box, CircularProgress, Typography, alpha, createTheme, useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AppleIcon } from "../../assets/images/ralvie/icon_apple.svg";
import { ReactComponent as AppleIconDark } from "../../assets/images/ralvie/icon_apple_dark.svg";
import { ReactComponent as WindowsIcon } from "../../assets/images/ralvie/icon_windows.svg";
import { ReactComponent as SundialIconDark } from "../../assets/images/ralvie/SundailDark.svg";
import { ReactComponent as SundialIcon } from "../../assets/images/ralvie/Sundail.svg";
import AppContext from "../../config/AppContext";
import { eventFilter, getSundialDownloadStatus, userEventsCount } from "../../services/EventService";
import OnboardService from "../../services/OnboardService";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext, TimesheetContext } from "../../util/context";
import ActivityListItem from "./ActivityListItem";
import "./timesheet.scss";
import CustomIconButton from "../../components/CustomIconButton";
import { ReactComponent as DownloadIcon } from "../../assets/images/ralvie/downloadFile.svg";
import { toast } from "sonner";
import { getRandomColorVariantBasedOnAppName } from "./Day";

export default function ActivityList(props) {
  const { t } = useTranslation();
  const [step, setStep] = useState(30.1);
  const [isLoading, setIsLoading] = useState(true);
  const [appColor, setAppColor] = useState(new Map());
  const [formatedEventsList, setFormatedEvents] = useState([]);
  const [day, setDay] = useState("today");
  const [selectedDayByTz, setSelectedDayByTz] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date().getHours());
  const [startMinute, setStartMinute] = useState(0);
  const appColorRef = useRef(appColor);
  const calendarRef = useRef(null);
  const stepRef = useRef(step);
  const [eventInterval, setEventInterval] = useState(null);
  const eventIntervalRef = useRef(eventInterval);
  // const [eventsToLog, setEventsToLog] = useState();
  const timelineEventsRef = useRef([]);
  const { mode } = useContext(AppContext);
  const { reload, setReload,setEventsToLog,subEventSelected,SetSubEventSelected } = useContext(TimesheetContext);
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const [packages, setPackages] = useState([]);
  const [os, setOs] = useState("");
  const [userEventCount, setUserEventCount] = useState(0);
  const [userSundialStatus, setUserSundialStatus] = useState(true);
  const [companySundialStatus, setCompanySundialStatus] = useState(false);
  const { companyProfile } = useContext(sidebarContext);

  const companyName =
      companyProfile === null || companyProfile === undefined
        ? CommonUtil.getLoggedUser()?.companyName
        : typeof companyProfile === "object"
        ? companyProfile?.name
        : companyProfile;

  const logEvent = (event) => {
    setEventsToLog(event);
  };

  useEffect(() => {
    const userAgent = navigator.userAgent;
    if (/Mac|iPod|iPhone|iPad/.test(userAgent)) {
      setOs("macOS");
    } else if (/Win/.test(userAgent)) {
      setOs("Windows");
    } else if (/Linux/.test(userAgent)) {
      setOs("Linux");
    } else {
      setOs("unknown");
    }
  }, []);

  useEffect(() => {
    if (props.zoomLevel !== -1) {
      setStep(props.zoomLevel);
      stepRef.current = props.zoomLevel;
    }
  }, [props.zoomLevel]);

  useEffect(() => {
    props.setIsFilterDone(!isLoading);
  }, [isLoading]);

  useEffect(() => {
    // setDateByTimezone();
    if (reload) {
      setFormatedEvents([]);
      cleanupFunction();
      if (props.filter?.selectedDate) {
        loadActivities();
        if (props.filter?.selectedDate?.isSame(dayjs(), "day"))
          setEventsInterval(null);
      }
      setReload(false);
    }
  }, [reload]);

  const roundToNearestMinutes = (minute) => {
    if (step === 1) {
      return minute;
    }
    let roundedMinutes = Math.round(minute / step) * step;
    if (minute < roundedMinutes) {
      roundedMinutes = roundedMinutes - step;
    }
    return roundedMinutes;
  };

  const setEventsInterval = (e) => {
    if (e !== null || eventIntervalRef.current !== null) {
      return;
    }
    const eventInterval_ = setInterval(function () {
      loadActivities();
    }, 60 * 1000);
    setEventInterval(eventInterval_);
    eventIntervalRef.current = eventInterval_;
    return () => clearInterval(eventInterval_);
  };

  useEffect(() => {
    // setDateByTimezone();
    setFormatedEvents([]);
    cleanupFunction();
    if (props.filter?.selectedDate) {
      loadActivities();
      if (props.filter?.selectedDate?.isSame(dayjs(), "day"))
        setEventsInterval(null);
    }
  }, [props.filter]);

  // useEffect(() => {
  //   setFormatedEvents([]);
  //   cleanupFunction();
  //   if (props.filter?.selectedDate) {
  //     loadActivities();
  //     if (props.filter?.selectedDate?.isSame(dayjs(), "day")) {
  //       setEventsInterval(null);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const element = document.getElementById("currentTimeBar");
    const myElement = document.getElementsByClassName("css-vnle6y");
    const topPos = element?.offsetTop;
    if (myElement && myElement.length > 0)
      myElement[0].scrollTop =
        topPos -
        (window.innerHeight > 900
          ? window.innerHeight - 250
          : window.innerHeight - 200);
  }, [formatedEventsList]);

  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById("currentTimeBar");
      const myElement = document.getElementsByClassName("css-vnle6y");
      const topPos = element?.offsetTop;
      if (myElement && myElement.length > 0)
        myElement[0].scrollTop =
          topPos -
          (window.innerHeight > 900
            ? window.innerHeight - 250
            : window.innerHeight - 200);
    }, 10);
  }, [step, startTime]);

  useEffect(() => {
    // Function to be called on unmount
    return () => {
      cleanupFunction();
    };
  }, []); // Empty dependency array to run effect only once on mount

  // Function to be called on unmount
  function cleanupFunction() {
    clearInterval(eventIntervalRef.current);
    eventIntervalRef.current = null;
    setEventInterval(null);
  }

  function foramtEvents(events) {
    events = events?.sort(
      (a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );

    events = events?.filter((event) => event.duration >= 30);
    const formatedEvents = [];

    events?.forEach((e) => {
      const eventStart = new Date(e.start);
      const eventEnd = new Date(e.end);
      let key = e.application?.name;
      let color = getRandomColorVariantBasedOnAppName(key);
      const newEvent = {
        ...e,
        start: eventStart,
        end: eventEnd,
        event_id: e.eventId,
        light: color?.light,
        dark: color?.dark,
      };
      formatedEvents.push(newEvent);
    });
    if (step === 30.1) {
      setStep(30);
      stepRef.current = 30;
    }

    return formatedEvents;
  }

  const loadSundialPackages = () => {
    OnboardService.listSundialVersions()
      .then((res) => {
        if (res.data.code === "RCI0000") {
          const sundialPackages = res.data.data;
          if (sundialPackages instanceof Array && sundialPackages.length > 0) {
            setPackages(sundialPackages);
            return;
          } else {
            setPackages([
              {
                type: "exe",
                downloadLink:
                  "https://minervaiot-storage-service-global-staging.s3.ap-southeast-1.amazonaws.com/public/ralvie/sundial/beta/Sundial_3.0.0_beta.exe",
              },
              {
                type: "dmg",
                downloadLink:
                  "https://minervaiot-storage-service-global-staging.s3.ap-southeast-1.amazonaws.com/public/ralvie/sundial/beta/Sundial_3.0.0_beta.dmg",
              },
            ]);
          }
        }
      })
      .catch((error) => {});
  };

  const getUserEventsCount = () => {
    userEventsCount().then((res) => {
      setUserEventCount(res.data?.data);
    });
  };

  useEffect(() => {
    getUserEventsCount();
    getSundialDownloadStatus(CommonUtil.getLoggedUser().id).then((res) => {
      if (res.data.data) {
        setUserSundialStatus(res.data.data?.isSundialInstalled);
        setCompanySundialStatus(res.data.data?.isSundialInstalledInCompany);
      }
    });
  }, []);

  useEffect(() => {
    if (!userEventCount || userEventCount === 0) {
      loadSundialPackages();
    }
  }, [userEventCount]);

  const downloadSundial = (type) => {
    if (type && packages?.length > 0) {
      const link = document.createElement("a");
      let pkgs = packages.find((pkg) => pkg?.type?.toLowerCase() === type);
      if (pkgs) {
        link.href = pkgs?.downloadLink;
        link.download = "sundial_package";
        link.setAttribute("download", "sundial_package");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const loadActivities = () => {
    setIsLoading(true);
    var utc = require("dayjs/plugin/utc");
    var timezone = require("dayjs/plugin/timezone");
    dayjs.extend(utc);
    dayjs.extend(timezone);
    let dateTz = dayjs.tz(
      props.filter?.selectedDate,
      CommonUtil.getTimeZoneId()
    );
    let startDate = dateTz.startOf("day");
    let endDate = dateTz.endOf("day");
    let projectTaggedStatus = null;
    if (props.filter?.logged && props.filter?.unlogged) {
      projectTaggedStatus = "ALL";
    } else if (props.filter?.logged) {
      projectTaggedStatus = "LOGGED";
    } else if (props.filter?.unlogged) {
      projectTaggedStatus = "UNLOGGED";
    }
    if (
      !props.filter?.logged &&
      !props.filter?.unlogged &&
      !props.filter?.hidden
    ) {
      projectTaggedStatus = "ALL";
    } else if (
      !props.filter?.logged &&
      !props.filter?.unlogged &&
      props.filter?.hidden
    ) {
      projectTaggedStatus = "NONE";
    }
    let payload = {
      startTime: startDate.isUTC()
        ? startDate.format()
        : startDate.utc().format(),
      endTime: endDate.isUTC() ? endDate.format() : endDate.utc().format(),
      isHidden: props.filter?.hidden,
      projectTaggedStatus: projectTaggedStatus,
      windowTitle: props.filter.title,
      applicationName: props.filter.applicationName,
    };
    eventFilter(payload)
      .then((res) => {
        if (res.data?.data) {
          let startDateTime = new Date(
            new Date(res.data?.data?.startDateTime).toLocaleString("en-US", {
              timeZone: CommonUtil.getTimeZoneId(),
            })
          );

          setSelectedDayByTz(startDateTime);

          setStartTime(new Date(startDateTime).getHours());
          setUserEventCount(res.data?.data?.events?.length);
          setStartMinute(
            roundToNearestMinutes(new Date(startDateTime).getMinutes())
          );
          timelineEventsRef.current = res.data?.data?.events;
          // setStartMinute(roundToNearestMinutes(Number(res.data?.data?.startMin)));
          setFormatedEvents(foramtEvents(res.data?.data?.events));
        } else {
          setFormatedEvents([]);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setFormatedEvents([]);
      });
  };

  return (
    <>
      {formatedEventsList.length === 0 ? (
        <div className="noActivity">
          {isLoading && (
            <Box
              sx={{ display: "flex" }}
              width={"100%"}
              justifyContent={"center"}
            >
              <CircularProgress />
            </Box>
          )}
          {!isLoading && (
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              width={"80%"}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                pb={"0%"}
              >
                 {mode == "light" ? <SundialIcon /> : <SundialIconDark />}
                <div className="sundailparagraph">
                  <p
                    style={{
                      color: "var(--text-color-6) !important",
                      font: "normal normal normal 12px/22px Gotham",
                    }}
                  >
                    {props.filter?.title.length > 0 || props.filter?.applicationName.length > 0
                      ? t("RAL0397")
                      : userEventCount > 0
                      ? t("RAL0038")
                      : t("")}
                  </p>
                </div>

                {userEventCount < 1 && (
                  <Box>
                    {!userSundialStatus && !companySundialStatus && (
                      <>
                        <p className="worklog-caption">{t("RAL0956")}</p>
                      </>
                    )}
                    {userSundialStatus && companySundialStatus && (
                      <>
                        <p className="worklog-caption">{t("RAL0955")}</p>
                      </>
                    )}
                    {userSundialStatus && !companySundialStatus && (
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                      >
                       <p className="worklog-caption">
                          {t("RAL0957")?.split(/\.|。/g, 2)[0]}
                        </p>
                        <p className="worklog-caption">
                          {t("RAL0957")
                            ?.split(/\.|。/g, 2)[1]
                            ?.replace(
                              "{companyName}",
                              companyName || ''
                            )}
                        </p>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
              {userEventCount < 1 && packages && packages.length > 0 && (
                <Box
                  className="ActivityTrack"
                  flexDirection="column"
                  justifyContent={"space-between"}
                >
                  {os === "macOS" &&
                    packages?.find(
                      (pkg) => pkg?.type?.toLowerCase() === "dmg"
                    ) && (
                      <Box
                        onClick={() => downloadSundial("dmg")}
                        className={
                          mode === "dark"
                            ? "activity_track_package_dark"
                            : "activity_track_package"
                        }
                      >
                        {mode === "dark" ? (
                          <AppleIconDark className="Appleicontop" />
                        ) : (
                          <AppleIcon className="Appleicontop" />
                        )}
                        <Box
                          display={"flex"}
                          flexDirection={"row"}
                          px={"16px"}
                          flexGrow={1}
                          alignItems="center"
                        >
                          <Box>
                            <Typography className="header">
                              {t("RAL0728")}
                            </Typography>
                            <Typography className={"sub-title"}>
                              {t("RAL0729")}
                            </Typography>
                          </Box>
                          <Box display="inline-flex" ml="18px">
                            <CustomIconButton
                              size={isXlScreen ? "large" : "md"}
                              variant="square"
                              type="contained"
                              border={"none"}
                              lightMode={
                                <DownloadIcon
                                  height={isXlScreen ? "18px" : "14px"}
                                />
                              }
                              darkMode={
                                <DownloadIcon
                                  height={isXlScreen ? "18px" : "14px"}
                                />
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    )}
                  {os === "Windows" &&
                    packages?.find(
                      (pkg) =>
                        pkg?.type?.toLowerCase() === "exe" && pkg?.downloadLink
                    ) && (
                      <Box
                        className={
                          mode === "dark"
                            ? "activity_track_package_dark"
                            : "activity_track_package"
                        }
                        marginTop={2}
                        onClick={() => downloadSundial("exe")}
                      >
                        <WindowsIcon />
                        <Box
                          display={"flex"}
                          flexDirection={"row"}
                          px={"16px"}
                          flexGrow={1}
                          alignItems="center"
                        >
                          <Box>
                            <Typography
                              className="headers"
                              style={{
                                font: "normal normal 18px/28px GothamMedium",
                              }}
                            >
                              {t("RAL0730")}
                            </Typography>
                            <Typography className={"sub-title"}>
                              {t("RAL0731")}
                            </Typography>
                          </Box>
                          <Box display="inline-flex" ml="18px">
                            <CustomIconButton
                              size={isXlScreen ? "large" : "md"}
                              variant="square"
                              type="contained"
                              border={"none"}
                              lightMode={
                                <DownloadIcon
                                  height={isXlScreen ? "18px" : "14px"}
                                />
                              }
                              darkMode={
                                <DownloadIcon
                                  height={isXlScreen ? "18px" : "14px"}
                                />
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    )}
                  {os === "Linux" &&
                    packages?.find(
                      (pkg) => pkg?.type?.toLowerCase() === "tar"
                    ) && (
                      <Box
                        className={
                          mode === "dark"
                            ? "activity_track_package_dark"
                            : "activity_track_package"
                        }
                        marginTop={2}
                        onClick={() => downloadSundial("tar")}
                      >
                        <Typography className="header">
                          {t("Sundial for Linux")}
                        </Typography>
                        <Box display="inline-flex" ml="18px">
                          <CustomIconButton
                            size={isXlScreen ? "large" : "md"}
                            variant="square"
                            type="contained"
                            border={"none"}
                            lightMode={
                              <DownloadIcon
                                height={isXlScreen ? "18px" : "14px"}
                              />
                            }
                            darkMode={
                              <DownloadIcon
                                height={isXlScreen ? "18px" : "14px"}
                              />
                            }
                          />
                        </Box>
                      </Box>
                    )}
                </Box>
              )}
            </Box>
          )}
        </div>
      ) : (
        <div id="list" className="listView">
          {formatedEventsList.map((event) => (
            <ActivityListItem
              event={event}
              stepRef={stepRef}
              logEvent={(event) => logEvent(event)}
            />
          ))}
        </div>
      )}
    </>
  );
}
